/**
 * Mega menú Catálogo: hover + despliegue animado hacia abajo (estilo Leonline).
 */
(function () {
  const HOVER_QUERY = '(min-width: 990px) and (hover: hover)';
  const ANIM_MS = 580;

  function bindCatalogMegaMenu(menu) {
    const details = menu.querySelector('details.mega-menu--yunke-catalog');
    const summary = details && details.querySelector('summary');
    const panel = details && details.querySelector('.mega-menu__content');
    if (!details || !summary || !panel) return;

    const mq = window.matchMedia(HOVER_QUERY);
    let closeTimer;

    const expand = () => {
      panel.classList.add('yunke-catalog-mega__content--expanded');
    };

    const collapse = () => {
      panel.classList.remove('yunke-catalog-mega__content--expanded');
    };

    const open = () => {
      if (!mq.matches) return;
      window.clearTimeout(closeTimer);
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
        collapse();
        void panel.offsetHeight;
        requestAnimationFrame(() => {
          requestAnimationFrame(expand);
        });
      } else if (!panel.classList.contains('yunke-catalog-mega__content--expanded')) {
        expand();
      }
      summary.setAttribute('aria-expanded', 'true');
    };

    const scheduleClose = () => {
      if (!mq.matches) return;
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        collapse();
        window.setTimeout(() => {
          if (!panel.classList.contains('yunke-catalog-mega__content--expanded')) {
            details.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          }
        }, ANIM_MS);
      }, 140);
    };

    menu.addEventListener('mouseenter', open);
    menu.addEventListener('mouseleave', scheduleClose);
    details.addEventListener('mouseenter', open);
    details.addEventListener('mouseleave', scheduleClose);

    details.addEventListener('toggle', () => {
      if (!details.hasAttribute('open')) {
        collapse();
      }
      summary.setAttribute('aria-expanded', details.hasAttribute('open') ? 'true' : 'false');
    });
  }

  function init() {
    document.querySelectorAll('header-menu.yunke-catalog-mega-menu').forEach(bindCatalogMegaMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
